<div class="annual-status-wrapper">
    <div class="status" [class]="AnnualStatementStatus[status!]">
      {{ AnnualStatementStatus[status!] | splitByCapitalLetterPipe }}
    </div>
</div>
